import { render, staticRenderFns } from "./instances-transfer-modal.vue?vue&type=template&id=f461bf1e&scoped=true&"
import script from "./instances-transfer-modal.vue?vue&type=script&lang=ts&"
export * from "./instances-transfer-modal.vue?vue&type=script&lang=ts&"
import style0 from "./instances-transfer-modal.vue?vue&type=style&index=0&id=f461bf1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f461bf1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
